export const searchOverlay = () => {
	const searchOverlay = document.getElementById("search-overlay");
    const closeButton = document.getElementById('search-overlay-close');
	const searchInput = document.getElementById('search-form-input');
	if(!searchOverlay || !closeButton || !searchInput) return;
	const openSearch = (e) => {
        e.preventDefault();
		document.body.classList.add('--scroll-disabled');
        searchOverlay.hidden = false;
        searchOverlay.classList.add('is-active');
        // Set a timeout to allow the transition to start before focusing
        setTimeout(() => {
            searchInput.focus();
        }, 100);
    };

    const closeSearch = () => {
        document.body.classList.remove('--scroll-disabled');
        searchOverlay.classList.remove('is-active');
        // Hide the element after the transition is complete
        searchOverlay.addEventListener('transitionend', () => {
            searchOverlay.hidden = true;
        }, { once: true });
    };

	if (closeButton) {
        closeButton.addEventListener('click', closeSearch);
    }

	document.addEventListener('click', (e) => {
		if (e.target.matches('.header__nav-search')) {
			openSearch(e);
		}
	});

	// Close with the Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
            closeSearch();
        }
    });

    // Close if clicking outside the content area (on the overlay background)
    searchOverlay.addEventListener('click', (e) => {
        if (e.target === searchOverlay) {
            closeSearch();
        }
    });

}